export default __webpack_public_path__ + "static/GRID2022-NDs-Share-afc27e603833733b93cebaaa512669d9.jpg";